import { doc, onSnapshot } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { db } from '../backend/firebase'

const User = ({userId, func, title}) => {
    const [userDetails, setUserDetails] = useState([])
    useEffect(() => {
        const userRef = doc(db, "Users", userId)
        const unsub = onSnapshot(userRef, (data) => {
            if(data.exists()){
                setUserDetails({
                    id: data.id,
                    ...data.data()
                })
            }
        })
        return () => unsub()
    }, [userId])
    
  return (
    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', backgroundColor: '#1a1a1a', padding: 10, borderRadius: 3}}>
    <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
    <img src={userDetails.profile_pic} style={{height: 40, width: 40, borderRadius: 200}} />
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
        <span style={{color: 'white', fontWeight:'bold', fontSize: 16}}>{userDetails.displayName}</span>
        <span style={{color: 'grey', fontSize: 14}}>{userDetails.email}</span>
    </div>
    </div>

        <span style={{color: 'whitesmoke', cursor: 'pointer', backgroundColor: 'rgba(0, 0, 0, 0.3)', padding: 5, borderRadius: 3, fontSize: 14}} onClick={func}>
            {title}
        </span>
    </div>
  )
}

export default User
